import { type PrimeVueLocaleOptions } from 'primevue'
import COLORS from '../json/colors.json'

// can be any type in lib -___-
export const customColors: Readonly<object> = {
    primary: {
        50: COLORS['primary-50'],
        100: COLORS['primary-100'],
        200: COLORS['primary-200'],
        300: COLORS['primary-300'],
        400: COLORS['primary-400'],
        500: COLORS['primary-500'],
        600: COLORS['primary-600'],
        700: COLORS['primary-700'],
        800: COLORS['primary-800'],
        900: COLORS['primary-900'],
        950: COLORS['primary-950'],
    },
} as const

// TODO: localization
export const customLocale: Readonly<PrimeVueLocaleOptions> = {
    accept: 'Да',
    addRule: 'Добавить правило',
    am: 'ппн',
    apply: 'Применить',
    aria: {
        cancelEdit: 'Отменить изменения',
        close: 'Закрыть',
        collapseRow: 'Скрыть',
        editRow: 'Редактировать строку',
        expandRow: 'Раскрыть',
        falseLabel: 'False',
        filterConstraint: 'Filter Constraint',
        filterOperator: 'Filter Operator',
        firstPageLabel: 'Первая страница',
        gridView: 'Таблица',
        hideFilterMenu: 'Скрыть фильтры',
        jumpToPageDropdownLabel: 'Jump to Page Dropdown',
        jumpToPageInputLabel: 'Jump to Page Input',
        lastPageLabel: 'Последняя страница',
        listLabel: 'Option List',
        listView: 'Список',
        moveAllToSource: 'Move All to Source',
        moveAllToTarget: 'Move All to Target',
        moveBottom: 'Переместить в самый низ',
        moveDown: 'Переместить вниз',
        moveTop: 'Переместить на самый верх',
        moveToSource: 'Move to Source',
        moveToTarget: 'Move to Target',
        moveUp: 'Переместить вверх',
        navigation: 'Навигация',
        next: 'Следующий/ая',
        nextPageLabel: 'Следующая страница',
        nullLabel: 'Не выбрано',
        pageLabel: 'Страница {page}',
        previous: 'Предыдущий/ая',
        prevPageLabel: 'Предыдущая страница',
        rotateLeft: 'Повернуть влево',
        rotateRight: 'Повернуть вправо',
        rowsPerPageLabel: 'Строк на странице',
        saveEdit: 'Сохранить изменения',
        scrollTop: 'Вверх',
        selectAll: 'Выбрано все',
        selectRow: 'Строка выделена',
        showFilterMenu: 'Показать фильтры',
        slide: 'Изображение',
        slideNumber: '{slideNumber}',
        star: '1 звезда',
        stars: '{star} звезд(ы)',
        trueLabel: 'True',
        unselectAll: 'Ничего не выбрано',
        unselectRow: 'Строка не выделена',
        zoomImage: 'Увеличить изображение',
        zoomIn: 'Увеличить',
        zoomOut: 'Уменьшить',
    },
    cancel: 'Отмена',
    choose: 'Выбрать',
    chooseDate: 'Выберите день',
    chooseMonth: 'Выберите месяц',
    chooseYear: 'Выберите год',
    clear: 'Очистить',
    completed: 'Закончено',
    contains: 'Включает в себя',
    dateAfter: 'Дата позднее',
    dateBefore: 'Дата ранее',
    dateFormat: 'dd.mm.yy',
    dateIs: 'Дата',
    dateIsNot: 'Дата не',
    dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    dayNamesShort: ['Вск', 'Пнд', 'Втр', 'Срд', 'Чтв', 'Птн', 'Сбт'],
    emptyFilterMessage: 'Ничего не найдено',
    emptyMessage: 'Нет данных',
    emptySearchMessage: 'Ничего не найдено',
    emptySelectionMessage: 'Ничего не выбрано',
    endsWith: 'Заканчивается на',
    equals: 'Равно',
    fileChosenMessage: '{0} файл(а/ов)',
    fileSizeTypes: ['Б', 'KB', 'MB', 'ГБ', 'ТБ', 'ПБ', 'ЭБ', 'ЗБ', 'ИБ'],
    firstDayOfWeek: 1,
    gt: 'Больше чем',
    gte: 'Больше или равно',
    lt: 'Меньше чем',
    lte: 'Меньше или равно',
    matchAll: 'Match All',
    matchAny: 'Match Any',
    medium: 'Средняя сложность',
    monthNames: [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
    ],
    monthNamesShort: [
        'Янв',
        'Фев',
        'Мар',
        'Апр',
        'Май',
        'Июн',
        'Июл',
        'Авг',
        'Сен',
        'Окт',
        'Ноя',
        'Дек',
    ],
    nextDecade: 'Следующее десятилетие',
    nextHour: 'Следующий час',
    nextMinute: 'Следующая минута',
    nextMonth: 'Следующий месяц',
    nextSecond: 'Следующая секунда',
    nextYear: 'Следующий год',
    noFileChosenMessage: 'Файл не выбран',
    noFilter: 'Фильтры не выбраны',
    notContains: 'Не включает в себя',
    notEquals: 'Не равно',
    passwordPrompt: 'Введите пароль',
    pending: 'Ожидание',
    pm: 'ппд',
    prevDecade: 'Предыдущее десятилетие',
    prevHour: 'Предыдущий час',
    prevMinute: 'Предыдущая минута',
    prevMonth: 'Предыдущий месяц',
    prevSecond: 'Предыдущая секунда',
    prevYear: 'Предыдущий год',
    reject: 'Нет',
    removeRule: 'Удалить правило',
    searchMessage: 'Найдено {0} вариантов',
    selectionMessage: 'Выбрано {0} элементов',
    showMonthAfterYear: false,
    startsWith: 'Начинается с',
    strong: 'Надежный',
    today: 'Сегодня',
    upload: 'Загрузить',
    weak: 'Слишком слабый',
    weekHeader: 'Нед',
} as const
